export const ROLE_NAMES = {
	VEX: 'VEX',
	VEX_SUPPORT: 'VEX Support',
	SYSTEM_ADMINISTRATOR: 'System Administrator',
	SERVICE_PROVIDER: 'Service Provider',
	VKO: 'VKO',
	VKO_EXTERNAL: 'VKO External',
	APPROVER: 'Approver',
	READER: 'Reader',
	BEDARFSKOORDINATOR: 'Bedarfskoordinator',
	REGULATION_READER: 'Regulation Reader',
	AVK: 'AnlagenVorschriftenKoordinator',
	BAV: 'Bereichsexperte Anlagenvorschriften',
	AVK_ADMINISTRATOR: 'AVK Administrator',
} as const;

// Token string -> display name. Tokens are the verbatim Azure app-role values (e.g. "Readers",
// "VEX_Support") and don't map 1:1 to ROLE_NAMES keys, hence this explicit lookup.
const ROLE_DISPLAY_BY_TOKEN: Record<string, string> = {
	SYSTEM_ADMINISTRATOR: ROLE_NAMES.SYSTEM_ADMINISTRATOR,
	VKO: ROLE_NAMES.VKO,
	VKO_EXTERNAL: ROLE_NAMES.VKO_EXTERNAL,
	SERVICE_PROVIDER: ROLE_NAMES.SERVICE_PROVIDER,
	VEX: ROLE_NAMES.VEX,
	VEX_Support: ROLE_NAMES.VEX_SUPPORT,
	SH_APPROVER: ROLE_NAMES.APPROVER,
	REGULATION_READER: ROLE_NAMES.REGULATION_READER,
	Readers: ROLE_NAMES.READER,
	AVK: ROLE_NAMES.AVK,
	BAV: ROLE_NAMES.BAV,
	AVK_ADMINISTRATOR: ROLE_NAMES.AVK_ADMINISTRATOR,
	BEDARFSKOORDINATOR: ROLE_NAMES.BEDARFSKOORDINATOR,
	// PURE: heavily-restricted allow-listed reader (enforced by PureFieldsAuthorizationMiddleware).
	// Mapped so it counts as a user-facing role.
	PURE: 'Pure',
};

export const roleDisplayName = (tokenRole: string): string =>
	ROLE_DISPLAY_BY_TOKEN[tokenRole] ?? tokenRole;

// User-facing business roles have a display name; system/app roles (ALL_PAG_USERS, IRPA_APP…) don't.
export const isUserFacingRole = (tokenRole: string): boolean =>
	ROLE_DISPLAY_BY_TOKEN[tokenRole] !== undefined;

// Verbatim Reader token casing (matches the token claim + X-Active-Role header).
export const READER_TOKEN_ROLE = 'Readers';

export const isReaderRole = (tokenRole: string): boolean =>
	tokenRole.toLowerCase() === READER_TOKEN_ROLE.toLowerCase();

export const toDisplayRoleNames = (tokenRoles: string[]): string[] =>
	tokenRoles
		.filter(isUserFacingRole)
		.map(roleDisplayName)
		.sort((a, b) => a.localeCompare(b));
